import { createContext, useContext, useState, useEffect } from "react";

const TooltipsContext = createContext();

export const TooltipsProvider = ({ children }) => {
    const [tooltipsTrigger, setTooltipsTrigger] = useState(true);
    const [tooltips, setTooltips] = useState();
    const [tooltipsLoading, setTooltipsLoading] = useState(true);

    useEffect(() => {
        const savedTrigger = localStorage.getItem("tooltips_trigger");
        const saved = localStorage.getItem("tooltips_cache");

        if (savedTrigger) {
            setTooltipsTrigger(JSON.parse(savedTrigger));
        }
        else {
            localStorage.setItem("tooltips_trigger", JSON.stringify(true));
        }

        if (saved) {
            setTooltips(JSON.parse(saved));
            setTooltipsLoading(false);
            return;
        }

        const fetchTooltips = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/qr_backend/tooltips/`);

                if (!res.ok) {
                    const text = await res.text().catch(() => "");
                    throw new Error(`API Error ${res.status} ${text}`);
                }
                const data = await res.json();
                setTooltips(data);
                localStorage.setItem("tooltips_cache", JSON.stringify(data));
            }
            catch (err) {}
            finally { setTooltipsLoading(false); }
        }

        fetchTooltips();
    }, []);

    const toggleTrigger = (state) => {
        setTooltipsTrigger(state);
        localStorage.setItem("tooltips_trigger", JSON.stringify(state));
    }

    return (
        <TooltipsContext.Provider value={{ tooltipsTrigger, tooltips, tooltipsLoading, toggleTrigger}}>
            {children}
        </TooltipsContext.Provider>
    );
};

export const useTooltips = () => useContext(TooltipsContext);
